import React, { FunctionComponent } from "react";
import { Box, Button } from "@mui/material";

import { CheckIcon } from "assets";
import { UTILITY_BILL_STATUSES } from "components";
import { UtilityBillByIdDTO } from "api";

interface SaveConfirmButtonsProps {
  isCreateMode: boolean;
  isAuditor: boolean;
  utilityBill?: UtilityBillByIdDTO;
  isSaveButtonDisabled: boolean;
  isConfirmButtonDisabled: boolean;
  isCreateButtonDisabled: boolean;
  onSaveChangesClick: () => void;
  onConfirmDataClick: () => void;
  onCreateBillClick: () => void;
}

export const SaveConfirmButtons: FunctionComponent<SaveConfirmButtonsProps> = ({
  isCreateMode,
  isAuditor,
  utilityBill,
  isSaveButtonDisabled,
  isConfirmButtonDisabled,
  isCreateButtonDisabled,
  onSaveChangesClick,
  onConfirmDataClick,
  onCreateBillClick,
}) => {
  if (isCreateMode) {
    return (
      <Button
        variant="contained"
        type="submit"
        name="save"
        startIcon={<CheckIcon />}
        onClick={onCreateBillClick}
        disabled={isCreateButtonDisabled}
      >
        Add bill
      </Button>
    );
  }

  if (isAuditor) {
    return null;
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        gap: 2,
      }}
    >
      <Button
        sx={{
          height: "fit-content",
        }}
        variant="contained"
        startIcon={<CheckIcon />}
        onClick={onSaveChangesClick}
        disabled={isSaveButtonDisabled}
      >
        Save changes
      </Button>
      {utilityBill?.status === UTILITY_BILL_STATUSES.VERIFICATION_FAILED && (
        <Button
          sx={{
            height: "fit-content",
          }}
          variant="outlined"
          name="manually-approve"
          startIcon={<CheckIcon />}
          onClick={onConfirmDataClick}
          disabled={isConfirmButtonDisabled}
        >
          Confirm data
        </Button>
      )}
    </Box>
  );
};

